export default "__VITE_ASSET__CGHkEL5i__"